import { Component, OnInit, ChangeDetectorRef} from '@angular/core';
import { CommonFilterService } from '../../services/common-filter/common-filter.service';
import { FilterMetadata, FilterMeta } from 'lib/ng-data-table';
import { DataFilter } from 'lib/ng-data-table/base/data-filter'; 
import { filter } from 'minimatch';

@Component({
  selector: 'app-synopsis',
  templateUrl: './synopsis.component.html',
  styleUrls: ['./synopsis.component.scss']
})
export class SynopsisComponent implements OnInit {
  private dataFilter: DataFilter;
  breakpoint;
  constructor(private commonFilterService: CommonFilterService, private cd: ChangeDetectorRef) {
    this.dataFilter = new DataFilter();
  }
  filtersArray: Array<any> = [];

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 400) ? 1 : 6;
  }

  ngOnInit() {
    this.breakpoint = (window.innerWidth <= 400) ? 1 : 6;
    this.commonFilterService.GeneralFilter.subscribe(res => {
      this.filtersArray = [];
      const filters: FilterMetadata = res;

      this.dataFilter.filters = filters;

      //console.log(filters)
      for (const key in filters) {
        if (filters[key]) {
          this.setFilterArray(key, filters[key]);
        }
      }

      //https://stackoverflow.com/questions/37849453/attempt-to-use-a-destroyed-view-detectchanges
      //https://stackoverflow.com/a/60060172
      //https://stackoverflow.com/questions/56056911/attempt-to-use-a-destroyed-view-detectchanges-event-though-the-view-is-detached
      if (!this.cd['destroyed']) {
        //https://suneetbansal.medium.com/angular-expressionchangedafterithasbeencheckederror-lets-see-why-it-comes-and-how-can-fix-it-22fc905ee01e - IMP
        this.cd.detectChanges();
      }
    });
  }

  //https://stackoverflow.com/questions/46562305/angular-4-how-to-dynamically-add-and-delete-rows-in-a-table/46562718
  private setFilterArray(key: string, filter: FilterMeta) {
    if (key.toLowerCase().indexOf('_timestamp') == -1) {
      debugger
      if (key.toLowerCase().indexOf('vquad_callid') != -1 && filter.matchMode.toLowerCase().indexOf('contains') != -1
        && filter.value.indexOf('_') == 0 && filter.value.lastIndexOf('_') == filter.value.length - 1
        && filter.value.substring(1, filter.value.length - 1).indexOf('_') == -1) {
        let newVal = filter.value.substring(1, filter.value.length - 1);
        let newMatchMode = filter.matchMode.indexOf('not') != -1 ? 'notEqual' : 'equals';
        this.filtersArray.push({ columnName: key, column: filter.title, operator: (this.dataFilter.getOperatorType(newMatchMode))[1], value: newVal, valueTo: filter.valueTo });
      }
      else
        this.filtersArray.push({ columnName: key, column: filter.title, operator: (this.dataFilter.getOperatorType(filter.matchMode))[1], value: filter.value, valueTo: filter.valueTo });
    }
    //filter.title.replace(new RegExp('<br/>', 'g'), ' ')
  }

  deleteFilter(columnName) {
    //https://love2dev.com/blog/javascript-remove-from-array/
    for (var i = 0; i < this.filtersArray.length; i++) {

      if (this.filtersArray[i].columnName === columnName) {
        this.filtersArray.splice(i, 1);
        i--;
      }
    }

    this.commonFilterService.setDeleteFilterData(columnName);//Set deleted column here

    //console.log('del')
    //if (columnName == 'VQuad_CallID')
    //  this.commonFilterService.setGeneralEventIDFilterData({});
  }
}
